import { useEffect, useMemo, useState } from 'react';

import { DialogTitle } from '@mui/material';
import {
  ESelfServeTaskStatus,
  ETaskId,
  TaskCategories
} from 'common/contracts';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader
} from 'components/ui/dialog';

import { VerifyBusinessFormContainer } from './Form/Container';

const SuccessHeader: React.FC<{ onResend: () => void }> = ({ onResend }) => (
  <DialogHeader className="flex flex-col text-center my-auto">
    <DialogTitle className="!p-0 text-center my-auto text-2xl">
      Thanks!
    </DialogTitle>
    <DialogDescription className="text-base-mutedForeground font-normal text-sm mx-auto text-center">
      We’ll contact you shortly to complete verification.
    </DialogDescription>
    <DialogDescription
      onClick={onResend}
      className="text-base-mutedForeground font-normal text-sm mx-auto text-center cursor-pointer hover:text-base-foreground mt-2 underline"
    >
      Resend business details
    </DialogDescription>
  </DialogHeader>
);

export const VerifyBusinessModal: React.FC = () => {
  const {
    isVerifyBusinessModalOpen,
    setIsVerifyBusinessModalOpen,
    toggleChecklistExpandedState,
    setTaskStatus,
    categories
  } = useChecklistState();

  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);

  const taskStatus: ESelfServeTaskStatus | undefined = useMemo(() => {
    return categories
      ?.find(({ title }) => title === TaskCategories.VERIFY_BUSINESS)
      ?.tasks.find(({ id }) => id === ETaskId.VERIFY_BUSINESS_CONTACT)?.status;
  }, [categories]);

  useEffect(() => {
    setHasSubmitted(taskStatus !== ESelfServeTaskStatus.OPEN);
  }, [taskStatus]);

  const handleSuccess = () => {
    setHasSubmitted(true);

    setTimeout(() => {
      handleClose();
    }, 20000);

    setTaskStatus(
      ETaskId.VERIFY_BUSINESS_CONTACT,
      ESelfServeTaskStatus.PENDING
    );
  };

  const handleClose = () => {
    setIsVerifyBusinessModalOpen(false);
    setTimeout(() => {
      setHasSubmitted(taskStatus !== ESelfServeTaskStatus.OPEN);
    }, 500);
    toggleChecklistExpandedState(false);
  };

  return (
    <Dialog open={isVerifyBusinessModalOpen} onOpenChange={handleClose}>
      <DialogContent
        className="w-[42vw] max-w-[608px] h-[655px] px-20 py-16 bg-white z-1000 mx-auto"
        showCloseButton
      >
        {hasSubmitted ? (
          <SuccessHeader onResend={() => setHasSubmitted(false)} />
        ) : (
          <VerifyBusinessFormContainer onSuccess={handleSuccess} />
        )}
      </DialogContent>
    </Dialog>
  );
};
